module.exports = __webpack_public_path__ + "static/media/S1N2-4.e17939b6.svg";